import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { IoCloudUploadOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { CandidateUpdateProImg } from "../../../Redux/action/CandidateUpdateProImgAction";
import { MdOutlineLocalPhone, MdOutlineMail, MdVerified } from "react-icons/md";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import VideoModal from "../../Candidate/CandidateDashboard/VideoModal";
import dummyDp from "../../../../src/images/dummy_dp.png";
import video from "../../../../src/images/video_img.jpg";
import { AiOutlineLinkedin, AiOutlineSkype } from "react-icons/ai";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Swal from "sweetalert2";
import Pricing from "../../Candidate/Profile/Pricing";
import { SiWhatsapp } from "react-icons/si";
import BackButton from "../../Common/BackButton/BackButton";
import Loader from "../../Common/Loader/loader";

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        width: "0",
        height: "0",
        borderTop: "10px solid transparent",
        borderBottom: "10px solid transparent",
        borderRight: "10px solid #417f9c",
        margin: "10px",
      }}
      onClick={onClick}
    />
  );
}
function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        width: "0",
        height: "0",
        borderTop: "10px solid transparent",
        borderBottom: "10px solid transparent",
        borderLeft: "10px solid #417f9c",
        margin: "10px",
      }}
      onClick={onClick}
    />
  );
}

const ProjectCarousel = ({ images }) => {
  if (images.length === 1) {
    return (
      <div style={{ textAlign: "left" }}>
        <a href={images[0]} target="_blank">
          <img
            src={images[0]}
            alt="Project Image"
            style={{ width: "85%", height: "200px", objectFit: "contain" }}
          />
        </a>
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Slider style={{ margin: "20px" }} {...settings}>
        {images.map((image, index) => (
          <div key={index} className="d-flex justify-content-center">
            <a href={image} target="_blank">
              <img
                src={image}
                alt={`Project Image ${index + 1}`}
                style={{ width: "90%", height: "200px", objectFit: "" }}
              />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const AppliedCandidateView = () => {
  const userInfo = useSelector((state) => state?.Profile?.result);
  const userVideo = useSelector((state) => state?.Profile?.result?.videoUrl);
  const loading = useSelector((state) => state?.Profile?.loading);
  const [showOverlay, setShowOverlay] = useState(false);

  const [isPriceOpen, setIsPriceOpen] = useState(false);

  const fileInputRef = useRef();

  const [image, setImage] = useState({ preview: "", raw: "" });

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [file, setFile] = useState(null);
  const [isOpenForMarket, setIsOpenForMarket] = useState();
  const [vendorIdFromLocalstorage, setVendorIdFromLocalstorage] =
    useState(null);

  const location = useLocation();
  const dispatch = useDispatch();
  const param = useParams();
  const queryParams = new URLSearchParams(location?.search);
  const CandidateId = queryParams.get("candidateId");
  const candidateId = CandidateId ? CandidateId : param?.id;

  useEffect(() => {
    setIsOpenForMarket(userInfo?.availableForWork);
    dispatch(CandidateProfile(candidateId));
  }, [userInfo?.availableForWork]);

  function SwitchButton() {
    return (
      <Form>
        <Form.Check
          type="switch"
          id="custom-switch"
          checked={isOpenForMarket}
          onChange={handleIsMarketChange}
        />
      </Form>
    );
  }

  const handleIsMarketChange = async () => {
    try {
      if (isOpenForMarket === true) {
        return handleToggle();
      }

      setIsOpenForMarket(!isOpenForMarket);

      const content = {
        candidateId: userInfo?.candidateId,
        availableForWork: true,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_PATH}/ebench/update_Candidate`,
        content
      );
    } catch (error) {
      console.error(
        "Error updating candidate:",
        error.response?.data || error.message
      );
    }
  };
  const { userResult } = useSelector((state) => state.Auth);
  useEffect(() => {
    const vID = userResult?.vendorid;
    setVendorIdFromLocalstorage(vID);

    if (location.state === null) {
      dispatch(CandidateProfile(candidateId));
    } else {
      dispatch(CandidateProfile(location.state.id));
    }
  }, []);

  const fileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInBytes = file.size;
      const maxSizeInBytes = 1024 * 1024; // 1MB
      if (fileSizeInBytes > maxSizeInBytes) {
        toast.error("File size exceeds 1MB. Please select a smaller file.");
        e.target.value = null;
      } else {
        setImage({
          preview: URL.createObjectURL(e.target.files[0]),
          raw: e.target.files[0],
        });
        const datas = new FormData();
        datas.append("image", file);
        datas.append("candidateId", candidateId);

        dispatch(CandidateUpdateProImg(datas))
          .then(() => {
            setShowOverlay(false);
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
            toast.error("Error uploading image");
          });
      }
    }
  };

  useEffect(() => {
    setImage(userInfo?.profileImageUrl);
  }, [userInfo]);

  const [showModal, setShowModal] = useState(false);

  let maxLength = 20;
  const truncateString = (str) => {
    if (str?.length > maxLength) {
      return str?.slice(0, maxLength) + "...";
    } else {
      return str;
    }
  };
  const handleToggle = (jobId) => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
        .custom-confirm-button {
            background-color: #286a94 !important;
            color: white;
            border-bottom: 1px solid rgb(57, 57, 57);
            
        }
        .custom-title {
            border-bottom: 0.5px solid #adadad;
            text-align:center;
            color: #286a94 !important;
            padding-bottom: 10px;
        }
    `;
    document.getElementsByTagName("head")[0].appendChild(style);
    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText =
      "Are you sure you want to change the availablity for your team member?";
    Swal.fire({
      title: "Change Unavailablity Status",
      html: para.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsOpenForMarket(false);

          let content = {
            candidateId: userInfo?.candidateId,
            availableForWork: false,
          };
          const response = await axios.put(
            `${process.env.REACT_APP_API_PATH}/ebench/update_Candidate`,
            content
          );
        } catch (error) {
          console.error("Error deleting job:", error);
          Swal.fire("Error", "There was an error deleting the job", "error");
        }
      }
    });
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const vendorEmail = userResult?.email;

  const getDomain = (email) => {
    const domain = email?.split("@")[1];
    return domain;
  };
  const isSameDomain = getDomain(userInfo?.email) === getDomain(vendorEmail);

  if (loading) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div
      style={
        location.pathname.includes("admin")
          ? {
              marginTop: 0,
              backgroundColor: "white",
              minHeight: "100vh",
              overflow: "auto",
            }
          : {}
      }
    >
      <div
        className="profile_wrapper"
        style={location.pathname.includes("admin") ? { marginTop: 10 } : {}}
      >
        <div
          className="profile_container"
          style={
            location.pathname.includes("admin")
              ? {
                  width: "95%",
                  marginTop: 0,
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: width > 768 ? "row" : "column",
                }
              : {}
          }
        >
          <div className="prof_left" style={{ backgroundColor: "white" }}>
            <div className="prof_can_info">
              <div
                className="can_img_wrapper"
                style={{ cursor: "pointer", position: "relative" }}
              >
                {/* <div className="d-flex justify-content-between">
                  <BackButton />
                </div> */}
                <div className="can_img_wrapper" style={{ cursor: "pointer" }}>
                  <div className="can_img">
                    <img
                      src={
                        isSameDomain
                          ? userInfo?.profileImageUrl ? userInfo?.profileImageUrl : dummyDp : dummyDp
                      }
                      alt="profile"
                    />
                    {showOverlay && (
                      <div className="image-overlay">
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <IoCloudUploadOutline size={30} color="#fff" />
                          <p className="upload-text">Upload Image</p>
                        </div>
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={fileInputRef}
                      onChange={fileChange}
                    />
                  </div>
                </div>
              </div>
              <div className="prof_can_avail mt-4">
                <div>
                  <p>
                    <div style={{ display: "flex" }}>
                      <div style={{ minWidth: "65%" }}>
                        {" "}
                        {isSameDomain ? userInfo?.firstName : 'This candidate'} is{" "}
                        <b
                          className={
                            isOpenForMarket ? "text-success" : "text-danger"
                          }
                        >
                          {isOpenForMarket ? "Available" : "Unavailable"}
                        </b>
                      </div>{" "}
                      {userInfo?.vendorId == vendorIdFromLocalstorage && (
                        <div style={{ marginLeft: "5px" }}>
                          <SwitchButton />
                        </div>
                      )}
                    </div>
                    {userInfo?.vendorId == vendorIdFromLocalstorage && (
                      <div style={{ fontSize: "14px" }}>
                        <span style={{ color: "#286a94" }}>
                          <b>Last Login: </b>
                        </span>
                        {userInfo?.lastLogin
                          ? userInfo?.lastLogin?.split(" ")[0] + " "
                          : "N/A"}
                        <b>
                          {userInfo?.lastLogin
                            ? userInfo?.lastLogin?.split(" ")[1].split(":")[0] +
                              ":" +
                              userInfo?.lastLogin?.split(" ")[1].split(":")[1] +
                              " "
                            : ""}
                        </b>{" "}
                        {userInfo?.lastLogin
                          ? userInfo?.lastLogin?.split(" ")[2]
                          : ""}
                      </div>
                    )}
                  </p>
                </div>
              </div>
              <div className="prof_can_vid"></div>
            </div>

            {userInfo?.vendorId == vendorIdFromLocalstorage && (
              <div className="prof_contactInfo" style={{ marginTop: "25px" }}>
                <p className="mb-0 fw-bold block_head">CONTACT INFORMATION</p>
                <p className="mb-0">
                  <span
                    className="me-2 arc_tooltip"
                    data-tooltip={userInfo?.email ? `${userInfo.email}` : "N/A"}
                  >
                    <MdOutlineMail size={23} color="#2e2988" />
                  </span>
                  {truncateString(userInfo?.email) || "N/A"}
                </p>
                <p className="mb-0">
                  <span
                    className="me-2 arc_tooltip"
                    data-tooltip={
                      userInfo?.mobile ? `${userInfo.mobile}` : "N/A"
                    }
                  >
                    <MdOutlineLocalPhone size={23} color="#2e2988" />
                  </span>
                  {userInfo?.countryCode ? "+" + userInfo?.countryCode : ""}{" "}
                  {truncateString(userInfo?.mobile) || "N/A"}
                </p>
                <p className="mb-0">
                  <span
                    className="me-2 arc_tooltip"
                    data-tooltip={
                      userInfo?.linkedIn ? `${userInfo.linkedIn}` : "N/A"
                    }
                  >
                    <AiOutlineLinkedin size={23} color="#2e2988" />
                  </span>
                  {truncateString(userInfo?.linkedIn) || "N/A"}
                </p>
                <p className="mb-0">
                  <span
                    className="me-2 arc_tooltip"
                    data-tooltip={
                      userInfo?.whatsapp
                        ? `${
                            userInfo?.dialCode +
                            " " +
                            userInfo?.whatsapp
                          }`
                        : "N/A"
                    }
                  >
                    <SiWhatsapp size={23} color="#2e2988" />
                  </span>
                  {userInfo?.whatsappCountryCode
                    ? "+" + userInfo?.dialCode
                    : ""}{" "}
                  {truncateString(userInfo?.whatsapp) || "N/A"}
                </p>
                {/* <p className='mb-0'>
                                    <span className='me-2 arc_tooltip' data-tooltip={userInfo?.skypeId ? `${userInfo.skypeId}` : "N/A"}><AiOutlineSkype size={23} color='#2e2988' /></span>
                                    {truncateString(userInfo?.skypeId) || 'N/A'}
                                </p> */}
              </div>
            )}
          </div>

          <div className="prof_right">
            <div className="prof_can_data">
              <div className="prof_can_name d-flex gap-3 align-items-center flex-row justify-content-lg-between justify-content-around flex-grow">
                <div className="w-50">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    { userInfo?.firstName + " " + userInfo?.lastName || ''}
                  </p>
                </div>
                <div className="d-flex align-items-center responsive-flex flex-column gap-2">
                  {userInfo?.candidatePrice && (
                    <button className="btn btn-outline-primary-custom position-relative" onClick={() => setIsPriceOpen(!isPriceOpen)} style={{ padding: "6px 30px", }}>
                      <p
                        className="mb-0 fs_16 pointer"
                      >
                        Price
                        {!isPriceOpen ? (
                          <FaChevronRight
                            size={18}
                            style={{ marginBottom: "3px" }}
                          />
                        ) : (
                          <FaChevronDown
                            size={18}
                            style={{ marginBottom: "3px" }}
                          />
                        )}
                        &nbsp; &nbsp;
                      </p>

                      {isPriceOpen && (
                        <div
                          className="position-absolute can_price_container p-2"
                          style={{ minWidth: "200px", right: "-40px", color: "#286a94" }}
                        >
                          {userInfo?.candidatePrice?.perHour && (
                            <p className="mb-2 fs_16">
                              {userInfo?.candidatePrice?.currency === "USD"
                                ? "$"
                                : userInfo?.candidatePrice?.currency === "INR"
                                  ? "₹"
                                  : userInfo?.candidatePrice?.currency + " "}
                              {userInfo?.candidatePrice?.perHour} / hr
                              <div className="line_divide mt-2"></div>
                            </p>
                          )}
                          {userInfo?.candidatePrice?.perDay && (
                            <p className="mb-2 fs_16">
                              {userInfo?.candidatePrice?.currency === "USD"
                                ? "$"
                                : userInfo?.candidatePrice?.currency === "INR"
                                ? "₹"
                                  : userInfo?.candidatePrice?.currency + " "}
                              {userInfo?.candidatePrice?.perDay} / day
                              <div className="line_divide mt-2"></div>
                            </p>
                          )}

                          {userInfo?.candidatePrice?.perWeek && (
                            <p className="mb-2 fs_16">
                              {userInfo?.candidatePrice?.currency === "USD"
                                ? "$"
                                : userInfo?.candidatePrice?.currency === "INR"
                                ? "₹"
                                  : userInfo?.candidatePrice?.currency + " "}{" "}
                              {userInfo?.candidatePrice?.perWeek} / week
                              <div className="line_divide mt-2"></div>
                            </p>
                          )}

                          {userInfo?.candidatePrice?.perMonth && (
                            <p className="mb-2 fs_16">
                              {userInfo?.candidatePrice?.currency === "USD"
                                ? "$"
                                : userInfo?.candidatePrice?.currency === "INR"
                                ? "₹"
                                  : userInfo?.candidatePrice?.currency + " "}
                              {userInfo?.candidatePrice?.perMonth} / month
                              <div className="line_divide mt-2"></div>
                            </p>
                          )}
                        </div>
                      )}
                    </button>
                  )}

                  {userInfo?.resumeFileUrl &&
                    userInfo?.vendorId == vendorIdFromLocalstorage && (
                      <a href={userInfo?.resumeFileUrl} target="_blank">
                      <button type="button" class="btn btn-outline-primary-custom">
                          View Resume
                        </button>
                      </a>
                    )}
                  {userInfo?.videoUrl && (
                    <button style={{ padding: "6px 18px", }}
                      onClick={handleShow}
                      className="btn btn-outline-primary-custom"

                    >
                      Introduction 
                    </button>
                  )}
                  {/* </a> */}
                </div>
              </div>
              <div className="can_role">
                <p className="mb-1">
                  {userInfo?.currentDesignation && (
                    <span style={{ paddingRight: "10px" }}>
                      {userInfo?.currentDesignation}
                    </span>
                  )}
                  {userInfo?.profileCompleteness !== "INCOMPLETE" ? (
                    <span>
                      {" "}
                      <MdVerified color="green" />{" "}
                    </span>
                  ) : (
                    <span
                      style={{
                        border: "0.5px solid red",
                        borderRadius: "5px",
                        padding: "2px 5px",
                        fontSize: "10px",
                        backgroundColor: "red",
                        color: "white",
                      }}
                    >
                      Incomplete
                    </span>
                  )}
                </p>
                <p className=" mb-2 can_id">
                  {" "}
                  <span className="text-dark">Candidate ID : </span>
                  {userInfo?.candidateEmpId}
                </p>
              </div>

              <div className="prof_can_desc text-secondary">
                {userInfo?.overview}
              </div>

              <div className="line_divide mt-4"></div>

              <div
                className="mt-3 prof_right_block"
                style={{ flexWrap: "wrap", gap: width > 319 ? "10px" : "" }}
              >
                <div>
                  <p className="mb-0 fw-bold right_block_head">LOCATION</p>
                  <p>
                    {userInfo?.city || "N/A"}{" "}
                    {userInfo?.district ? ", " + userInfo?.district : ""}{" "}
                    {userInfo?.state ? ", " + userInfo?.state : ""}{" "}
                    {userInfo?.country ? ", " + userInfo?.country : ""}
                  </p>
                </div>
                <div>
                  <p className="mb-0 fw-bold right_block_head">EXPERIENCE</p>
                  <p>
                    {(() => {
                      const years = parseInt(userInfo?.keyExperience) || 0;
                      const months =
                        parseInt(userInfo?.keyExperienceInMonth) || 0;
                      if (years === 0 && months === 0) return "Fresher";
                      if (years === 0)
                        return `${months} Month${months > 1 ? "s" : ""}`;
                      if (months === 0)
                        return `${years} Year${years > 1 ? "s" : ""}`;
                      return `${years} Year${
                        years > 1 ? "s" : ""
                      } ${months} Month${months > 1 ? "s" : ""}`;
                    })()}
                  </p>
                </div>
              </div>
              <div className="line_divide mt-4"></div>
              <div className="mt-3 prof_right_block">
                <div>
                  <p className="mb-0 fw-bold right_block_head">SKILLS</p>
                  <p className="fw-normal ">
                    <div className="d-flex gap-1 mt-2 flex-wrap">
                      {userInfo?.candidateSkills?.length > 0 &&
                        userInfo?.candidateSkills?.map((item, index) => (
                          <div
                            className={`skillWrap ${
                              item.experience && "arc_tooltip"
                            }`}
                            data-tooltip={item.experience}
                          >
                            {item.skills}
                          </div>
                        ))}
                      {userInfo?.skillList?.length === 0 && <p>N/A</p>}
                    </div>
                  </p>
                </div>
              </div>
              <div className="prof_projects my-4">
                <div className="prof_projects_container">
                  <div className="projects_head">
                    <p className="mb-0 fw-bold right_block_head">PROJECTS</p>
                  </div>
                  <div className="prof_projects_info">
                    {userInfo?.candidateProjects?.map((item) => (
                      <div className="prof_project_card mb-2">
                        <div style={{ marginTop: "10px" }}>
                          <div className="d-flex justify-content-between">
                            <p className="">
                              <span className="fw_500">Title: </span>{" "}
                              {item?.projectName}
                              <span className="fw-normal text-secondary">
                                {" "}
                                ({item?.duration})
                              </span>
                            </p>
                          </div>
                          <p>
                            <span className="fw_500">Description: </span>{" "}
                            <span
                              className="text-secondary"
                              style={{
                                whiteSpace: "pre-line",
                                wordBreak: "break-word",
                              }}
                            >
                              {item?.description}
                            </span>
                          </p>
                          <p className="prof_proj_role ">
                            <p className="mb-1">
                              <b className="fw_500">Role :</b>{" "}
                              <span className="text-secondary">
                                {item?.role}
                              </span>
                            </p>
                            <p className="mb-1">
                              <b className="fw_500">Project URL :</b>{" "}
                              <span className="text-secondary">
                                {item?.projectUrl || "N/A"}
                              </span>
                            </p>
                            <p className="mb-1">
                              <b className="fw_500">Technologies :</b>{" "}
                              <span className="text-secondary">
                                {item?.technologies?.map((item, index) =>
                                  index !== item?.technologies?.length - 1
                                    ? `${item}, `
                                    : item
                                )}
                              </span>
                            </p>
                          </p>
                          {item.projectImages &&
                            item.projectImages.length > 0 && (
                              <div
                                className="project-carousel-container"
                                style={{ height: "200px" }}
                              >
                                <ProjectCarousel images={item?.projectImages} />
                              </div>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* ========== education ===================  */}
              {userInfo?.educations?.length > 0 && (
                <div className="prof_projects my-4">
                  <div className="prof_projects_container">
                    <div className="projects_head">
                      <p className="mb-0 fw-bold right_block_head">
                        EDUCATIONAL
                      </p>
                    </div>
                    <div className="prof_projects_info">
                      {userInfo?.educations.map((item) => (
                        <div className="prof_project_card d-flex justify-content-between align-items-center px-4">
                          <div className="fw_500 ">
                            {item?.type || "N/A"}
                            {item?.degreeName && (
                              <div
                                className=" text-secondary"
                                style={{ color: "" }}
                              >
                                {item?.degreeName || "N/A"}
                              </div>
                            )}
                           
                          </div>
                          <div
                            className=" text-secondary"
                            style={{ color: "" }}
                          >
                            {item?.educationStatus === "PURSUING" ? (
                              <div> PURSUING </div>
                            ) : (
                              <div>{item?.passingYear || "N/A"}</div>
                            )}
                            {item?.percentage && (
                              <div>{item?.percentage + "%" || "N/A"}</div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
             
            </div>
          </div>
        </div>
        <VideoModal
          showModal={showModal}
          handleClose={handleClose}
          title="Introduction"
          body={
            <div
              className="profile-video d-flex justify-content-center"
              style={{ margin: "20px 0px" }}
            >
              <label htmlFor="videoInput">
                {userVideo ? (
                  <video
                    style={{ borderRadius: "5px" }}
                    alt="video"
                    width="100%"
                    height="300px"
                    controls
                  >
                    <source src={userVideo} type="video/mp4" />
                  </video>
                ) : selectedVideo ? (
                  <video
                    style={{ borderRadius: "5px" }}
                    alt="video"
                    width="100%"
                    height="160px"
                    controls
                  >
                    <source
                      src={URL.createObjectURL(selectedVideo)}
                      type="video/mp4"
                    />
                  </video>
                ) : (
                  <>
                    <img
                      style={{ borderRadius: "5px" }}
                      alt="video"
                      src={video}
                    />
                  </>
                )}
              </label>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default AppliedCandidateView;
